import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {FormGroup, FormControl, Validators} from '@angular/forms';
import {Variation} from '@emm/common-items/models/variation.model';

@Component({
    selector: 'emm-edit-variation-dialog',
    templateUrl: './edit-variation-metadata-dialog.component.html',
    styleUrls: ['./edit-variation-metadata-dialog.component.scss']
})
export class EditVariationMetadataDialogComponent implements OnInit {
    form: FormGroup;

    constructor(
        private dialogRef: MatDialogRef<EditVariationMetadataDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: { variation: Variation }
    ) {}

    ngOnInit() {
        this.form = new FormGroup({
            variationLabel: new FormControl(this.data.variation.variationLabel?.trim() || '', [
                Validators.required,
                this.noWhitespaceValidator
            ]),
            variationDescription: new FormControl(this.data.variation.variationDescription?.trim() || '', [
                Validators.required,
                this.noWhitespaceValidator
            ])
        });
    }

    noWhitespaceValidator(control: FormControl) {
        const isWhitespace = (control.value || '').trim().length === 0;
        const isValid = !isWhitespace;
        return isValid ? null : { whitespace: true };
    }

    close(): void {
        this.dialogRef.close();
    }

    save() {
        if (this.form.valid) {
            this.dialogRef.close({
                variationLabel: this.form.get('variationLabel').value.trim(),
                variationDescription: this.form.get('variationDescription').value.trim()
            });
        }
    }
}
